// removed by extract-text-webpack-plugin
module.exports = {"header":"Picklists__header___15Y6_","customer":"Picklists__customer___2wCtr","date":"Picklists__date___1V5Z9","route":"Picklists__route___3CQNW","caption":"Picklists__caption___2UkQI","table":"Picklists__table___2ukrV","left":"Picklists__left___ktz3Z","center":"Picklists__center___3_0Mu","nowrap":"Picklists__nowrap___PvpYR","picklist":"Picklists__picklist___1_SUa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Reports/Smallfish/Picklists/Picklists.scss
// module id = 1252
// module chunks = 1